import React from 'react';
import './styles.css';
import { Col, Row } from 'antd';
import BupImage from '@BUP/assets/Images/Data/BUPCIRCULAR.png';

const BupImageData = () => (
  <Row className="bupImage_container">
    <Col span={24} align="center">
      <img src={BupImage} alt="" style={{ width: '60%' }} />
    </Col>
  </Row>
);

export default BupImageData;
